import { render } from "./IntArgument.vue?vue&type=template&id=35db247a&scoped=true"
import script from "./IntArgument.vue?vue&type=script&lang=js"
export * from "./IntArgument.vue?vue&type=script&lang=js"

import "./IntArgument.vue?vue&type=style&index=0&id=35db247a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35db247a"

export default script